import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

interface PostCardProps {
    item?: any;
    selectedType?: string;
    active?: string;
    action?: () => void;
}

const PostCard = ({ item, active, action }: PostCardProps) => {
    return (
        <Link
            onClick={action}
            href={item.uri}
            className={`shrink-0 snap-start flex lg:flex-col bg-gray-50 dark:bg-transparent items-center border dark:border-white/20 gap-3 dark:hover:bg-white/5 overflow-hidden rounded-xl transition-all ${active === 'true' ? 'max-lg:w-full lg:w-[24%]' : 'w-48 lg:w-96 flex-col'}`}
        >
            {item.featuredImage && (
                <Image
                    width={2000}
                    height={2000}
                    src={item.featuredImage}
                    alt={item.title || 'post_card_image'}
                    className={`shrink-0 aspect-video object-cover lg:w-full  ${active === 'true' ? 'w-3/12 rounded-s-md' : 'w-full rounded-t-md'}`}
                />
            )}
            <p
                className={`basis-auto text-wrap text-start flex px-2 lg:pb-1 text-sm  ${active === 'true' ? 'py-0' : 'pb-1 lg:text-sm text-xs'} justify-start items-center text-black/70 dark:text-white/70`}
            >
                {item.title}
            </p>
        </Link>
    );
};

export default PostCard;
